export const mensurationSteps = [
	{
		id: "waterTreatment",
		label: "Uso de Água",
		className: "breadcrumb",
		step: true
	},
	{
		id: "measurementSectorization",
		label: "Setorização da Medição",
		className: "breadcrumb",
		step: true
	},
	{
		id: "effluentTreatment",
		label: "Tratamento Efluente",
		className: "breadcrumb",
		step: true
	},
	{
		id: "finalProduct",
		label: "Produto Final",
		className: "breadcrumb",
		step: true
	},
	{
		id: "input",
		label: "Insumo",
		className: "breadcrumb",
		step: true
	},
	{
		id: "others",
		label: "Outros Usos de Água",
		className: "breadcrumb",
		step: true
	}
];


// WEBPACK FOOTER //
// src/models/lib/tabs/mensurationSteps.js